export default "__VITE_ASSET__C5P43oBN__"